import { atomFamily } from 'jotai/utils';
import { atom } from 'jotai';
import NewsModel from '../Models/NewsModel';
import apiClient, { InkyApiError, InkyApiStatus } from '../API/InkyAPI';
import { Article } from '../Models/Article';
import { Product } from '../Models/Product';
import { ProductErrorAtom } from './ProductStore';
import inkyAPI from '../API/InkyAPI';
import Log from '../InkyPenV1/Services/Logger';

export enum ArticleFetchState {
    NotFetched,
    Fetched,
    Error
}

interface ArticleWrapper {
    fetchState: ArticleFetchState,
    article?: Article,
    errorMessage?: string
}

export const ArticleAtomFamily = atomFamily(() => atom<ArticleWrapper>({
    fetchState: ArticleFetchState.NotFetched
}));

export const FetchNewsAtom = atomFamily((id: string) =>
    atom(
        (get) => {
            return get(ArticleAtomFamily(id)).fetchState;
        },
        async (get, set) => {
            const cachedArticle = get(ArticleAtomFamily(id));

            if (cachedArticle?.fetchState === ArticleFetchState.Fetched) {
                return cachedArticle;
            }

            try {
                // set(ArticleFetchStateAtom, ArticleFetchState.NotFetched);
                const fetchedArticle = await apiClient.getArticle(id.toString(), 600);
                if (fetchedArticle) {
                    set(ArticleAtomFamily(id), {
                        fetchState: ArticleFetchState.Fetched,
                        article: fetchedArticle,
                    });
                }
                else {
                    Log.warn('Article not found');
                    set(ArticleAtomFamily(id), {
                        fetchState: ArticleFetchState.Error,
                        errorMessage: 'Article was not found'
                    });
                }
            } catch (e) {

                if (e instanceof InkyApiError) {
                    console.warn('InkyAPi Error', e.status);
                    if (e.status == InkyApiStatus.NotFound) {
                        Log.warn('Article not found');
                        set(ArticleAtomFamily(id), {
                            fetchState: ArticleFetchState.Error,
                            errorMessage: 'Article was not found'
                        });
                    }
                } else {
                    set(ArticleAtomFamily(id), {
                        fetchState: ArticleFetchState.Error,
                        errorMessage: 'Article was not found'
                    });
                    Log.error('[NewsArticleStore] Could not fetch Article-data: ' + e.message);
                    throw e;
                }
            }
        }),
);


/**
 * @returns Breadcrumb articles. (Without content)
 */
export const NewsArticlesAtom = atom<Article[]>([]);

export const FetchNewsArticlesAtom = atom(
    null,
    async (get, set, count: number) =>{
    apiClient.getNewsV2(count, 0, '600').then(articles => {
        set(NewsArticlesAtom,articles);
        console.log('articles', articles);
    }).catch(e => {
        throw e;
    });
});

export const NewsPagesAtom = atom<{ [key: number]: Article[] }>({});
